import { Main } from './pages';

function App() {
  return <Main />;
}

export default App;
